import { Box, Flex, Text, VStack, Heading, Link } from '@chakra-ui/react'
import { BITCOIN_ORANGE } from './constants'

const Privacy = () => {
	return (
		<Box
			w="100vw"
			h="100vh"
			bg="black"
			color="white"
			position="relative"
		>
			<Box
				w="100%"
				h="100%"
				overflow="auto"
			>
				<Flex
					w="100%"
					direction="column"
					align="center"
					justify="flex-start"
					p={{ base: 4, md: 8 }}
				>
					<VStack spacing={8} align="start" w="100%" maxW="800px">
						<Box>
							<Heading as="h1" size="lg" mb={4} color={BITCOIN_ORANGE}>
								Privacy Policy
							</Heading>
							
							<Text fontSize="sm" color="gray.400" mb={2}>
								Effective Date: JULY 25, 2025
							</Text>
							<Text fontSize="sm" color="gray.400" mb={6}>
								Last Updated: JULY 26, 2025
							</Text>

							<Text mb={6} color="gray.300">
								TIMECHAIN CALENDAR LLC (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) respects your privacy. This Privacy Policy
								describes how we collect, use, and protect limited user information when you use our
								mobile applications or software services (&ldquo;Services&rdquo;) available through the Apple App Store
								and Google Play Store.
							</Text>

							<Text mb={6} color="gray.300">
								We are a software and app development company based in California, and we only collect
								basic identifiers required for app functionality. We do not sell or share your data, and we do
								not collect sensitive personal information or analytics data.
							</Text>
						</Box>

						<Box w="100%">
							<Heading as="h2" size="md" mb={4}>
								1. Information We Collect
							</Heading>
							<Text mb={4} color="gray.300">
								We collect only the following identifiers, depending on your device and platform:
							</Text>
							
							<Box pl={4} mb={4}>
								<Text fontWeight="bold" mb={2}>a. Apple Users (iOS)</Text>
								<Text pl={4} color="gray.300">• A device identifier (used only for user preferences and session management)</Text>
							</Box>

							<Box pl={4} mb={4}>
								<Text fontWeight="bold" mb={2}>b. Android / Google Play Users</Text>
								<Text pl={4} color="gray.300">• A device identifier (used only for user preferences and session management)</Text>
							</Box>

							<Text mb={2} color="gray.300">We do not collect:</Text>
							<Box pl={4} color="gray.300">
								<Text>• Your personal info of any kind</Text>
								<Text>• Location data</Text>
								<Text>• Payment information</Text>
								<Text>• Usage analytics</Text>
								<Text>• Contact lists, photos, or other device content</Text>
							</Box>
						</Box>

						<Box w="100%">
							<Heading as="h2" size="md" mb={4}>
								2. How We Use Your Information
							</Heading>
							<Text mb={4} color="gray.300">
								We use the device identifiers solely for the following purposes:
							</Text>
							<Box pl={4} color="gray.300" mb={4}>
								<Text>• To create your user account</Text>
								<Text>• To maintain your session and personalize your experience in-app</Text>
								<Text>• To provide personalized features like push notifications</Text>
							</Box>
							<Text color="gray.300">
								We do not use your information for advertising, data analytics, or resale.
							</Text>
						</Box>

						<Box w="100%">
							<Heading as="h2" size="md" mb={4}>
								3. Information Sharing
							</Heading>
							<Text mb={4} color="gray.300">
								We do not sell or rent your information. We do not share your identifiers with third parties,
								except:
							</Text>
							<Box pl={4} color="gray.300">
								<Text mb={2}>
									• Apple or Google, as necessary for platform-related services (such as push notifications or
									authentication)
								</Text>
								<Text mb={2}>• Legal compliance: if required by law or subpoena</Text>
								<Text>
									• Business transfers: if the company is merged or acquired, with prior notice and
									appropriate safeguards
								</Text>
							</Box>
						</Box>

						<Box w="100%">
							<Heading as="h2" size="md" mb={4}>
								4. California Privacy Rights (CCPA)
							</Heading>
							<Text mb={4} color="gray.300">
								If you are a California resident, you have rights under the California Consumer Privacy Act
								(CCPA), including:
							</Text>
							<Box pl={4} color="gray.300" mb={4}>
								<Text>• Right to Know: What personal information we collect (see Section 1)</Text>
								<Text>• Right to Delete: You may request we delete your information</Text>
								<Text>• Right to Non-Discrimination: You will not be penalized for exercising your privacy rights</Text>
							</Box>
							<Text color="gray.300">
								To make a request, email us at{' '}
								<Link href="mailto:support@timechaincalendar.com" color={BITCOIN_ORANGE}>
									support@timechaincalendar.com
								</Link>.
							</Text>
						</Box>

						<Box w="100%">
							<Heading as="h2" size="md" mb={4}>
								5. Data Security
							</Heading>
							<Text color="gray.300">
								We implement reasonable technical and organizational measures to protect your
								information from unauthorized access, loss, or misuse. However, no method of data
								transmission over the internet or mobile networks is 100% secure.
							</Text>
						</Box>

						<Box w="100%">
							<Heading as="h2" size="md" mb={4}>
								6. Children&apos;s Privacy
							</Heading>
							<Text color="gray.300">
								Our Services are not directed to children under 13, and we do not knowingly collect
								personal data from them. If we become aware that a child has provided us with identifiers,
								we will promptly delete such data.
							</Text>
						</Box>

						<Box w="100%">
							<Heading as="h2" size="md" mb={4}>
								7. Changes to This Policy
							</Heading>
							<Text color="gray.300">
								We may update this Privacy Policy as our apps or legal requirements change. Updates will
								be posted here with a revised &ldquo;Last Updated&rdquo; date. Material changes will be communicated
								where required.
							</Text>
						</Box>

						<Box w="100%" pb={8}>
							<Heading as="h2" size="md" mb={4}>
								8. Contact Us
							</Heading>
							<Text mb={4} color="gray.300">
								If you have any questions or would like to exercise your privacy rights, please contact:
							</Text>
							<Box color="gray.300">
								<Text fontWeight="bold">TIMECHAIN CALENDAR LLC</Text>
								<Text>
									Email:{' '}
									<Link href="mailto:support@timechaincalendar.com" color={BITCOIN_ORANGE}>
										support@timechaincalendar.com
									</Link>
								</Text>
								<Text>Address: 530 Schoolhouse Rd Ste G, Hockessin DE 19707</Text>
							</Box>
						</Box>

						<Box w="100%" pt={8} borderTop="1px solid" borderColor="gray.700">
							<Link href="/" color={BITCOIN_ORANGE}>
								← Back to Timechain Calendar
							</Link>
						</Box>
					</VStack>
				</Flex>
			</Box>
		</Box>
	)
}

export default Privacy